import { LocationOpeningHoursState } from "./types";

export const state = (): LocationOpeningHoursState => initialState();

export const initialState = (): LocationOpeningHoursState => ({
  openingHours: []
});
